import { useI18n } from "@/context/I18nContext";

function pct(cur, ref) {
  if (!ref) return cur > 0 ? 100 : 0;
  return Math.min(100, Math.round((cur / ref) * 100));
}

export function NeuSpendingBars({ summary }) {
  const { lang } = useI18n();
  const daily = summary?.daily || [];
  const today = daily[daily.length - 1]?.amount || 0;
  const week = daily.slice(-7).reduce((s, d) => s + d.amount, 0);
  const month = summary?.this_month?.expense || 0;
  const lastMonth = summary?.last_month?.expense || 0;
  const year = month * 12; // rough estimate

  const monthCap = Math.max(month, lastMonth, 1);
  const dayCap = Math.max(week / 7, 1);
  const weekCap = Math.max(week, month / 4, 1);

  const bars = [
    { key: "Today", ar: "اليوم", pct: pct(today, dayCap), fill: "blue" },
    { key: "Week", ar: "الأسبوع", pct: pct(week, weekCap * 1.2), fill: "blue" },
    { key: "Month", ar: "الشهر", pct: pct(month, monthCap * 1.1), fill: "blue" },
    { key: "Year", ar: "السنة", pct: pct(year, monthCap * 15), fill: "yellow" },
  ];
  const title = lang === "ar" ? "معدل الصرف" : "Count down";

  return (
    <div className="neu p-6 h-full">
      <p className="font-display text-lg font-bold text-slate-700 mb-4">{title}</p>
      <div className="grid grid-cols-4 gap-3 sm:gap-5 items-end">
        {bars.map((b) => (
          <div key={b.key} className="flex flex-col items-center gap-2">
            <span className="text-xs font-bold neu-accent-blue tabular-nums">{b.pct}%</span>
            <div className="neu-inset w-6 h-32 rounded-full flex items-end p-1 overflow-hidden">
              <div
                className={`w-full rounded-full transition-all ${b.fill === "blue" ? "neu-fill-blue" : "neu-fill-yellow"}`}
                style={{ height: `${b.pct}%` }}
              />
            </div>
            <span className="text-xs font-semibold text-slate-500">{lang === "ar" ? b.ar : b.key}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
